import { render, staticRenderFns } from "./figureAuditNew.vue?vue&type=template&id=a2d613f2&scoped=true&"
import script from "./figureAuditNew.vue?vue&type=script&lang=js&"
export * from "./figureAuditNew.vue?vue&type=script&lang=js&"
import style0 from "./figureAuditNew.vue?vue&type=style&index=0&id=a2d613f2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2d613f2",
  null
  
)

export default component.exports